//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
// import UsuarioFinanceiroEdit from './UsuarioFinanceiroEdit';
import UsuarioFinanceiroListagemPage from './UsuarioFinanceiroListagemPage';
import UsuarioFinanceiroView from './UsuarioFinanceiroView';

export default class UsuarioFinanceiroIndex extends React.Component<{}> {
  render() {
    return (
      <Switch>
        <Route path="/usuarioFinanceiro/view/:id" component={UsuarioFinanceiroView} />
        <Route path="/usuarioFinanceiro" component={UsuarioFinanceiroListagemPage} />
      </Switch>
    );
  }
}
